export const mentions = [
  {
    name: 'Gaurav Sobti',
    title: 'Software Developer',
    avatar: 'https://d933oy9uoq0en.cloudfront.net/datamonk/Gaurav_Sobti.jpeg',
  },
  {
    name: 'Gaurav Chaubey',
    title: 'Director',
    avatar: 'https://d933oy9uoq0en.cloudfront.net/datamonk/Gaurav_Chaubey.jpeg',
  },
  {
    name: 'Pranav Mankar',
    title: 'Product Manager',
    avatar: 'https://d933oy9uoq0en.cloudfront.net/datamonk/Pranav.jpeg',
  },
  {
    name: 'Sakshi Arora',
    title: 'Senior Developer',
    avatar: 'https://d933oy9uoq0en.cloudfront.net/datamonk/Sakshi.jpeg',
  },
  {
    name: 'Arun Kumar',
    title: 'Backend Engineer',
    avatar: 'https://d933oy9uoq0en.cloudfront.net/datamonk/Arun.jpeg',
  },
  {
    name: 'Gourav Goyat',
    title: 'Sales Admin',
    avatar: 'https://d933oy9uoq0en.cloudfront.net/datamonk/Gourav_Goyat.jpeg',
  },
];

export const tags = [
  {
    name: 'AccountabilityAndEffort',
  },
  {
    name: 'LearningAndApplication',
  },
  {
    name: 'RelationshipAndTrust',
  },
  {
    name: 'HarmonyAndInclusion',
  },
  {
    name: 'FocusAndPriorities',
  },
  {
    name: 'InfluenceAndConviction',
  },
  {
    name: 'BravoAward',
  },
  {
    name: 'EinsteinAward',
  },
  {
    name: 'CustoMoreAward',
  },
  {
    name: 'RookieAward',
  },
  {
    name: 'ApprecationUnlimitiedAward',
  },
  {
    name: 'MadAward',
  },
];

export const money = [
  { name: 50 },
  { name: 100 },
  { name: 150 },
  { name: 200 },
  { name: 250 },
  { name: 300 },
  { name: 350 },
  { name: 400 },
  { name: 450 },
  { name: 500 },
  { name: 600 },
  { name: 700 },
  { name: 800 },
  { name: 900 },
  { name: 1000 },
];
